export const useStreamerStickersSettings = () => {
    return {

    };
};
